<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <!-- <a class="button is-success is-radiusless" @click="goTo('account/new')"> + Add New Account</a> -->
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Usuarios <a class="button is-success is-radiusless" @click="goTo('user/new')"> + </a></h3>
          <b-table :data="table.data" :striped="true" :hoverable="true" :paginated="true" :per-page="8">
            <template slot-scope="props">
              <b-table-column field="nombre" label="Nombre" sortable>
                  {{ props.row.name }}
              </b-table-column>
              <b-table-column field="correo" label="Correo" sortable>
                  {{ props.row.email }}
              </b-table-column>
              <!-- <b-table-column field="estado" label="Estado" sortable>
                  {{ props.row.status }}
              </b-table-column> -->
              <b-table-column field="actions" label="Acciones" sortable>
                <a class="button is-warning is-radiusless" @click="goTo('user/' + props.row.id)">
                  <font-awesome-icon :icon="['far','edit']"/></a>
                <a class="button is-danger is-radiusless" @click="deleteq(props.row.id)">
                  <font-awesome-icon :icon="['fa','times']"/></a>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import UsersService from '@/services/UsersService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
  },
  data () {
    return {
      table: {
        data: []
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      var users = await UsersService.fetchUser(this.$session.get('user').token)
      for (var i = 0; i < users.data.length; i++) {
        this.table.data.push(users.data[i])
      }
    },
    async deleteData (id) {
      var user = await UsersService.delUser({id: id}, this.$session.get('user').token)
      if (user.data.success) {
        this.$toast.open({
          message: 'Usuario eliminado',
          type: 'is-success'
        })
        // unset data
        var s = this.table.data.length
        for (var i = s - 1; i >= 0; i--) {
          if (this.table.data[i].id === id) {
            this.table.data.splice(i, 1)
          }
        }
      } else {
        this.alert('danger', 'Error, Intente nuevamente')
      }
    },
    deleteq (id) {
      this.$dialog.confirm({
        title: 'Eliminando usuario',
        message: 'Estas seguro que quieres <b>eliminar</b> este usuario?',
        confirmText: 'Eliminar Usuario',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: () => this.deleteData(id)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Users.vue